// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-12-04 16:22:15 +0100 (Thu, 04 Dec 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158950 $
//  Purpose   : config editors
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Table, Icon, Menu} from 'semantic-ui-react'

// ---Framework imports
import {Actions} from 'uix/registries'
import log from 'uix/logging'
import {HeaderSegment} from 'uix/components'
//~ import {DomainCSSViewer} from 'uix/templating/css'
import {loadLazy} from 'uix/parts'

// ---Local imports

import {DomainConfigTable} from '../components'
import {configIcon} from './utils'

// ---Globals

const ConfigTable = props => (
  <DomainConfigTable include={[]} levels="4" menu={true} menuPortal="ConfigMenuPortal" {...props} />
)

export const ShowConfig = () => (
  <HeaderSegment
    major
    header="Config"
    icon={configIcon('globe')}
    portal="ConfigMenuPortal"
    overflowInner
    flex
  >
    <ConfigTable flex section="root" exclude={['modsforms', 'templating']} />
  </HeaderSegment>
)
export const ShowFrontendConfig = () => (
  <HeaderSegment major header="Config" icon={configIcon('desktop')} portal="ConfigMenuPortal">
    <ConfigTable section="templating" />
  </HeaderSegment>
)

export const EditCSS = loadLazy(() => import(/* webpackChunkName: 'config' */ './domain_css'))

export const EditConfig = loadLazy(() =>
  import(/* webpackChunkName: 'config' */ './dconfig_editor')
)

export const ConfigHistory = loadLazy(() =>
  import(/* webpackChunkName: 'config' */ './dconfig_history')
)

export const DomainConfigChain = loadLazy(() =>
  import(/* webpackChunkName: 'config' */ './dconfig_chain')
)

export const ConfigDashboard = loadLazy(() =>
  import(/* webpackChunkName: 'config' */ './dashboard')
)

export const I18NDiag = loadLazy(() => import(/* webpackChunkName: 'config' */ './i18ndiag'))

import {I18NTable} from '../i18nedit'

export const TestI18N = ({dname}) => {
  return <I18NTable dname={dname} flex />
}
